<template>
  <div>
    <b-table :items="certificates"
             :fields="fields"
             responsive
             hover
             @row-clicked="value => selectCertificate(value)" />
  </div>
</template>

<script>
  /* services */
  import Bry from "@/helpers/Bry"

  export default {
    name: "ModalGlobalCertificados",
    data () {
      return {
        modalInfo: {
          title: 'Selecione um certificado',
          size: 'lg'
        },
        fields: [{
          key: 'name',
          sortable: true,
          label: 'Nome'
        }, {
          key: 'expirationDate',
          sortable: true,
          label: 'Validade'
        }, {
          key: 'cpf',
          sortable: true,
          label: 'CPF'
        }],
        certificates: []
      }
    },
    mounted () {
      this.certificates = Bry.certificates

      this.init()
    },
    methods: {
      init () {
        this.$emit('onGetConfig', this.modalInfo)
      },
      selectCertificate (value) {
        Bry.setCertificate(value)
      }
    }
  }
</script>

<style scoped>

</style>
